export default __webpack_public_path__ + "static/media/CBU-5.ae45e0d6.jpg";